import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import * as actions from "store/actions";
import { getActivePackagesList, getClientPackage, getFailedPackagesList, getPackageInvitationsList } from "store/services/packageService";
import PaymentForm from "./Components/PaymentForm/Index";
import { formatPrice } from "helpers/common";
import { profile } from "store/services/profileService";

const MyPackage = ({ dispatch, packageInvitations, activePackage, userDetails }) => {
  const [step, setStep] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [activePackagesList, setActivePackagesList] = useState(null);
  const [failedPackagesList, setFailedPackagesList] = useState([]);

  useEffect(() => {
    async function init() {
      try {
        setLoading(true);
        dispatch(actions.persist_store({ loader: true }));
        await Promise.all([
          getClientActivePackagesList(),
          getClientFailedPackagesList(),
          dispatch(getClientPackage()),
          dispatch(getPackageInvitationsList()),
          dispatch(profile()),
        ])
        dispatch(actions.persist_store({ loader: false }));
        setLoading(false);
      } catch (error) {
        console.log("error getting dashboard data", error);
        dispatch(actions.persist_store({ loader: false }));
        setLoading(false);
      }
    }

    init();
  }, []);

  const getClientActivePackagesList = async () => {
    try {
      let response = await getActivePackagesList();
      if(response.success === true && response?.body?.length) {
        setActivePackagesList(response?.body);
        return;
      }
      setActivePackagesList([]);
    } catch(err) {
      console.log("Error fetching active packages", err);
      setActivePackagesList([]);
    }
  }

  const getClientFailedPackagesList = async () => {
    try {
      let response = await getFailedPackagesList();
      if(response.success === true && response?.body?.length) {
        setFailedPackagesList(response?.body);
        return;
      }
      setFailedPackagesList([]);
    } catch(err) {
      console.log("Error fetching failed payment packages", err);
      setFailedPackagesList([]);
    }
  }

  const openPaymentForm = (packId) => {
    setSelectedPackage(packId);
    setStep(2);
  }


  return (
    <>
      <div className="top py-2">
        <h3 className="m-0 py-1 fw-bold">My Packages</h3>
      </div>
      <div className="TabBody py-2">
        <div className="info">
          {isLoading ? (
            <p>Loading...</p>
          ):(
            <Row>
              {step == 1 && (
                <>
                  {packageInvitations && packageInvitations.length > 0 && (
                    <Col lg="12">
                      <div className="py-2">
                        <p className="tex-muted m-0">
                          Hi {userDetails && userDetails.first_name}, <br /> {userDetails && userDetails.practitioner_name} has invited you to purchase the
                          following packages:
                        </p>
                      </div>
                      <div className="py-2">

                        {packageInvitations.map(pack => {
                          return (
                            <div className="commonCardBox my-3" key={pack.id || pack.package_invite_id || pack.package_name}>
                              <div className="top px-lg-4 p-3 border-bottom commonContent d-flex align-items-center justify-content-between">
                                <div className="left">
                                  <h3 className="m-0 fw-bold">{pack.package_name}</h3>
                                </div>
                                <div className="right">
                                  <h6 className="m-0 fw-sbold ws-nowrap theme-clr">
                                    Price{" "}
                                    <h4 className="m-0 fw-bold d-inline-block theme-clr">
                                     {pack.currency_sign}{formatPrice(pack.package_price)} ({pack.currency_code})
                                    </h4>
                                  </h6>
                                </div>
                              </div>
                              <div className="CardBody py-2 px-lg-4 px-3">
                                <div className="commonContent">
                                  <h4 className="m-0 py-2 fw-sbold">Description</h4>
                                  <p className="m-0 py-1 is-multiline">
                                    {pack.package_desc}
                                  </p>
                                </div>
                              </div>
                              <div className="CardFooter border-top py-2 px-lg-4 px-3">
                                <a
                                  href={pack?.invite_link}
                                  // target="_blank"
                                >
                                  <Button
                                    className="d-flex align-items-center justify-content-center commonBtn btnSm"
                                  >
                                    Purchase Package
                                  </Button>
                                </a>
                              </div>
                            </div>
                          )
                        })

                        }
                      </div>
                    </Col>
                  )}
                  {failedPackagesList?.length > 0 ? (
                    <Col lg="12">
                      <div
                        className="d-flex align-items-start gap-3 rounded p-3 mb-3"
                        style={{ background: "#fff3f3", border: "1px solid #f5c2c7" }}
                      >
                        <span
                          className="d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle text-danger fw-bold"
                          style={{ width: 36, height: 36, background: "#fde8e8", fontSize: 18, lineHeight: 1 }}
                          aria-hidden="true"
                        >
                          &#9888;
                        </span>
                        <div>
                          <h6 className="m-0 fw-bold text-danger">Action Required: Payment Failed</h6>
                          <p className="m-0 mt-1" style={{ color: "#842029", fontSize: "0.9rem" }}>
                            Your package access is paused. Please resolve the outstanding payment to restore access.
                          </p>
                        </div>
                      </div>

                      <Row>
                        {failedPackagesList.map((failedPackage) => {
                          const isResumable = failedPackage?.status === "payment_failed" && !!failedPackage?.resume_invoice_url;

                          return (
                            <Col lg="12" key={failedPackage.id || failedPackage.package_invite_id || failedPackage.package_name}>
                              <div
                                className="commonCardBox my-2"
                                style={{ borderLeft: "4px solid #dc3545" }}
                              >
                                <div className="top px-lg-4 p-3 border-bottom commonContent d-flex align-items-center justify-content-between flex-wrap gap-2">
                                  <div className="left">
                                    <h3 className="m-0 fw-bold">{failedPackage.package_name}</h3>
                                    <span
                                      className="badge mt-1 d-inline-block"
                                      style={{ background: "#fde8e8", color: "#dc3545", fontSize: "0.75rem", fontWeight: 600, padding: "4px 10px", borderRadius: 20 }}
                                    >
                                      &#10005; Payment Failed
                                    </span>
                                  </div>
                                  <div className="right text-end">
                                    <p className="m-0 fw-sbold" style={{ fontSize: "0.8rem", color: "#6c757d" }}>
                                      {failedPackage.payment_type === "installment" ? "Installment Due" : "Amount Due"}
                                    </p>
                                    <h4 className="m-0 fw-bold text-danger">
                                      {failedPackage.currency_sign}{formatPrice(
                                        failedPackage.payment_type === "installment"
                                          ? failedPackage.per_installment_amount
                                          : failedPackage.package_price
                                      )}
                                      <span className="ms-1" style={{ fontSize: "0.8rem", fontWeight: 500, color: "#6c757d" }}>
                                        ({failedPackage.currency_code})
                                      </span>
                                    </h4>
                                    {failedPackage.payment_type === "installment" && (
                                      <p className="m-0" style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                                        of {failedPackage.currency_sign}{formatPrice(failedPackage.package_price)} total
                                      </p>
                                    )}
                                  </div>
                                </div>

                                <div className="CardBody py-3 px-lg-4 px-3">
                                  <div className="commonContent">
                                    {failedPackage.package_desc && (
                                      <p className="m-0 pb-3 is-multiline" style={{ color: "#495057" }}>
                                        {failedPackage.package_desc}
                                      </p>
                                    )}
                                    <div
                                      className="d-flex align-items-start gap-2 rounded p-3"
                                      style={{ background: isResumable ? "#fff8e1" : "#f8f9fa", border: `1px solid ${isResumable ? "#ffe082" : "#dee2e6"}` }}
                                    >
                                      <p className="m-0" style={{ fontSize: "0.875rem", color: isResumable ? "#664d03" : "#495057" }}>
                                        {isResumable
                                          ? "Your installment plan is on hold. Complete the outstanding invoice below to immediately restore your package access."
                                          : "This installment plan was canceled due to non-payment and can no longer be resumed. You can repurchase the package to regain access."}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="CardFooter border-top py-3 px-lg-4 px-3 d-flex align-items-center gap-3 flex-wrap">
                                  {isResumable ? (
                                    <a
                                      href={failedPackage.resume_invoice_url}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <Button
                                        className="d-flex align-items-center justify-content-center commonBtn btnSm"
                                        style={{ minWidth: 120 }}
                                      >
                                        Pay Now
                                      </Button>
                                    </a>
                                  ) : null}
                                  {!isResumable && failedPackage?.invite_link ? (
                                    <a href={failedPackage.invite_link}>
                                      <Button
                                        className="d-flex align-items-center justify-content-center commonBtn btnSm"
                                        style={{ minWidth: 150 }}
                                      >
                                        Repurchase Package
                                      </Button>
                                    </a>
                                  ) : null}
                                  <span style={{ fontSize: "0.8rem", color: "#6c757d" }}>
                                    {isResumable
                                      ? "You will be redirected to a secure payment page."
                                      : "Contact your practitioner if you need assistance."}
                                  </span>
                                </div>
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    </Col>
                  ) : null}
                  {activePackagesList?.length > 0 && (
                    <Col lg="12">
                      <div className="py-2">
                        <h6 className="m-0 fw-bold text-uppercase">Active Packages</h6>
                        <p className="tex-muted m-0">
                          We have found following active package(s) on your account.
                        </p>
                      </div>
                      <Row>
                        {activePackagesList.map((activePackage) => {
                          return (
                            <Col lg="12" key={activePackage.id || activePackage.package_invite_id || activePackage.package_name}>
                              <div className="py-2">
                                <div className="commonCardBox my-1">
                                  <div className="top px-lg-4 p-3 border-bottom commonContent d-flex align-items-center justify-content-between">
                                    <div className="left">
                                      <h3 className="m-0 fw-bold">{activePackage.package_name}</h3>
                                    </div>
                                    <div className="right">
                                      <h6 className="m-0 fw-sbold ws-nowrap theme-clr">
                                        Price{" "}
                                        <h4 className="m-0 fw-bold d-inline-block theme-clr">
                                          {activePackage.currency_sign}{formatPrice(activePackage.package_price)} ({activePackage.currency_code})
                                        </h4>
                                      </h6>
                                    </div>
                                  </div>
                                  <div className="CardBody py-2 px-lg-4 px-3">
                                    <div className="commonContent">
                                      <h4 className="m-0 py-2 fw-sbold">Description</h4>
                                      <p className="m-0 py-1 is-multiline">
                                        {activePackage.package_desc}
                                      </p>
                                      <div className="py-2">
                                        <p className="m-0">
                                          <strong>Appointments Remaining: </strong>
                                          {activePackage.appointments_remaining}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          )
                        })}
                      </Row>
                    </Col>
                  )}
                  { !(packageInvitations && packageInvitations.length) && !activePackagesList?.length && !failedPackagesList?.length && !(activePackage) && (
                    <Col lg="12">
                      <div className="py-2">
                        <p className="tex-muted m-0">
                          You don't have any current or previous packages to show.
                        </p>
                      </div>
                    </Col>
                  )}
                </>
              )}
              {step == 2 && selectedPackage &&
                <Col lg="8" className="py-2">
                  <PaymentForm
                    packageId={selectedPackage}
                    userId={userDetails.id}
                  />
                </Col>
              }
              {step == 3 &&
                <Col lg="12">
                  <div className="CardFooter border-top py-2 px-lg-4 px-3">
                    <Button className="d-flex align-items-center justify-content-center commonBtn btnSm">
                      Purchase Complete
                    </Button>
                    <p className="py-2 m-0">
                      Your Purchase is complete <br />
                      You will recieve and email receipt shortly. If you have
                      any questions please contact NTA Academics.
                    </p>
                  </div>
                </Col>
              }
            </Row>
          )}
        </div>
      </div>
    </>
  );
};

{/* <>
  <div className="CardFooter border-top py-2 px-lg-4 px-3">
    <Button className="d-flex align-items-center justify-content-center commonBtn btnSm">
      Purchase Complete
    </Button>
    <p className="py-2 m-0">
      Your Purchase is complete <br />
      You will recieve and email receipt shortly. If you have
      any questions please contact NTA Academics.
    </p>
  </div>
</> */}

const mapStateToPros = (state) => {
  return {
    activePackage: state.Package.activePackage,
    packageInvitations: state.Package.packageInvitations,
    userDetails: state.Profile.user,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(MyPackage);